import {
  LABEL_BARCODE_LEFT_MM,
  LABEL_FOLD_MM,
  LABEL_INFO_LEFT_MM,
  LABEL_PRINT_GAP_MM,
  LABEL_PRINT_HEIGHT_MM,
  LABEL_PRINT_WIDTH_MM,
  mmToDots,
} from './inventoryLabelGeometry';

export interface InventoryLabelEplRow {
  productCodeUnique: string;
  materialLabel: string;
  salePrice: number;
  weightGrams: number | null;
  diameterSize?: string | null;
  workshopCode?: string | null;
}

function eplText(value: string, max = 40): string {
  return value
    .replace(/[\r\n"]/g, ' ')
    .trim()
    .slice(0, max);
}

function formatPriceBs(price: number): string {
  const n = Number(price);
  const s = n.toLocaleString('es-BO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `Bs. ${s}`;
}

function formatWeight(weightGrams: number | null): string {
  if (weightGrams == null || Number.isNaN(Number(weightGrams))) return '';
  return Number(weightGrams).toLocaleString('es-BO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/** EPL: empty 44 mm + two 22 mm panels (barcode | Plata/Bs). */
export function buildSingleLabelEpl(row: InventoryLabelEplRow): string {
  const q = mmToDots(LABEL_PRINT_WIDTH_MM);
  const Qh = mmToDots(LABEL_PRINT_HEIGHT_MM);
  const Qg = mmToDots(LABEL_PRINT_GAP_MM);
  const barX = mmToDots(LABEL_BARCODE_LEFT_MM);
  const infoX = mmToDots(LABEL_INFO_LEFT_MM);
  void LABEL_FOLD_MM;

  const material = eplText(row.materialLabel || '-');
  const price = eplText(formatPriceBs(row.salePrice));
  const weight = eplText(formatWeight(row.weightGrams));
  const code = eplText(row.productCodeUnique || '');
  const workshop = eplText(row.workshopCode || '', 22);
  const talla = eplText(row.diameterSize || '', 12);
  const barH = workshop ? 32 : 40;

  const lines = ['N', `q${q}`, `Q${Qh},${Qg}`];
  if (code) lines.push(`A${barX},6,0,1,1,1,N,"${code}"`);
  if (weight) lines.push(`A${barX + 100},6,0,1,1,1,N,"${weight}"`);
  if (code) lines.push(`B${barX},20,0,1A,2,2,${barH},N,"${code}"`);
  if (workshop) lines.push(`A${barX},54,0,1,1,1,N,"${workshop}"`);
  if (material) lines.push(`A${infoX},12,0,2,1,1,N,"${material}"`);
  if (price) lines.push(`A${infoX},42,0,2,1,1,N,"${price}"`);
  if (talla) {
    const tallaX = Math.min(infoX + price.length * 10 + 6, q - talla.length * 8 - 4);
    lines.push(`A${tallaX},46,0,1,1,1,N,"${talla}"`);
  }
  lines.push('P1', '');

  return lines.join('\n');
}

export function buildInventoryLabelsEpl(rows: InventoryLabelEplRow[]): string {
  return rows.map(buildSingleLabelEpl).join('');
}
